export default __webpack_public_path__ + "static/media/piece1.a06ecaab.png";